<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/119H4H6/tc-custom/9780795350948.jpg?1728726213959" alt="This image is the cover for the book Box Socials"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Box Socials
      </h1>
      <p class="bookDescription body article font2">
        <b>“A whimsical portrait of 1940s-era small-town life, crowded with everything from owl-calling contests to raucous, five-day Ukrainian weddings…delightful.”—<i>Los Angeles Times</i></b><br/><br/> This is the story of how Truckbox Al McClintock, a small-town greaser whose claim to fame was hitting a baseball clean across the Pembina River, almost got a tryout with the genuine St. Louis Cardinals—but instead ended up batting against Bob Feller of Cleveland Indian fame in Renfrew Park, Edmonton, Alberta. Along the way to Al's moment of truth at the plate, we learn about the bizarre, touchingly hilarious lives and loves of just about anyone who ever passed through New Oslo, Fark, or Venusberg. Full of the crackle of down-home folk tales, by turns randy, riveting, and heartbreaking, <i>Box Socials</i> is a triumph.<br/>  <br/> “Wonderful…Charming and funny…If you've never been to a box social, go to this one.”—Fannie Flagg, <i>The New York Times Book Review</i><br/><br/> “Kinsella, whose classic <i>Shoeless Joe</i> found another incarnation in the movie <i>Field of Dreams</i>, evokes the atmosphere of small-town ball fields and other aspects of rural life in this colorful, comic reminiscence of multi-ethnic farm society in Depression-era Canada.”—<i>Publishers Weekly</i><br/><br/> “A story filled with nostalgia about a time when the game was played on real grass and was called on account of darkness.”—<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W. P. Kinsella
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?90b75454